import React from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { Loader } from 'shared/components/Loader'
import { getSurveyFromId } from 'reducers'
import constants from 'config/constants'
import { connectApi } from 'libs/connectApi'
import { SurveyConfigurationPresentation } from 'organisms/SurveyConfiguration'
import { toast } from 'libs/toast'
import { Redirect } from 'react-router-dom'
import useAxios from 'hooks/useAxios'
import useFeatureToggle from 'hooks/useFeatureToggle'

export function SurveyConfigurationSettings({ survey }) {
  const { data: enabledMultiligualSurvey, loading: loadingEnabledMultiligualSurvey } = useAxios({
    url: 'billing/plans/feature-toggle/',
    method: 'post',
    data: { feature: 'multilingual_survey' },
  })
  const isEnabledMultiLanguageSurvey = R.path(['enabled'], enabledMultiligualSurvey)

  const { enableCtaButtonVariables, enableFileUploadQuestion } = useFeatureToggle()

  if (survey.error) {
    toast.error(constants.permissionDeniedErrorMessage)
    return <Redirect to="/settings/surveys/" />
  }

  if (survey.loading || loadingEnabledMultiligualSurvey) {
    return <Loader withContainer />
  }
  return (
    <SurveyConfigurationPresentation
      survey={survey}
      enabledMultiligualSurvey={isEnabledMultiLanguageSurvey}
      enableCtaButtonVariables={enableCtaButtonVariables}
      enableFileUploadQuestion={enableFileUploadQuestion}
    />
  )
}

const mapState = (state, props) => {
  const surveyId = props.match.params.surveyId
  return {
    survey: getSurveyFromId(state, surveyId),
    surveyId: surveyId,
  }
}

export default R.compose(
  withRouter,
  connect(mapState),
  connectApi({
    name: 'survey',
    url: (props) => `account/survey/${props.match.params.surveyId}/`,
  })
)(SurveyConfigurationSettings)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/SurveyConfigurationSettings.js